import { useEffect, useCallback, useState } from 'react';

import styles from './index.module.sass';

// import CLOCK from './assets-contador/reloj-contador.png';
//import COUNTER_IMG from './assets-contador/counter-img-web.png';
//import LOGO from './assets-contador/discount-desk.png';
// import LOGO_MOV from './assets-contador/descuento.png';
// import ADVICE from './assets-contador/advice-tag.png';
// import DISCOUNT from './assets-contador/descuento.png';

export default function CountDown({ device, setShowCount, target_date }) {
  // const deviceWidth = device.width;
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);

  function pad(n) {
    return (n < 10 ? '0' : '') + n;
  }

  const getCountdown = useCallback(() => {
    var current_date = new Date().getTime();

    if (target_date < current_date) {
      setShowCount(false);
      return;
    }

    // find the amount of "seconds" between now and target

    var seconds_left = (target_date - current_date) / 1000;

    setHours(pad(parseInt(seconds_left / 3600)));
    seconds_left = seconds_left % 3600;

    setMinutes(pad(parseInt(seconds_left / 60)));
    setSeconds(pad(parseInt(seconds_left % 60)));
  }, [target_date, setShowCount]);

  useEffect(() => {
    const intervalId = setInterval(function () {
      getCountdown();
    }, 1000);

    return () => clearInterval(intervalId);
  }, [getCountdown]);

  return (
    <div className={styles.containerContador}>
      <div id={styles.countdown}>
        <div className={styles.cdPromoTitle}>
          <div className={styles.cdtitle1}>QUEDAN POCAS HORAS</div>
          <div className={styles.cdtitle2}>¡APROVECHA YA!</div>
        </div>
        <div id={styles.tiles}>
          <div className={styles.numberContainer}>
            <div className={styles.labels}>Horas</div>
            <span>{hours}</span>
          </div>
          <div className={styles.numberContainer}>
            <div className={styles.labels}>Min</div>
            <span>{minutes}</span>
          </div>
          <div className={styles.numberContainer}>
            <div className={styles.labels}>Seg</div>
            <span>{seconds}</span>
          </div>
        </div>
      </div>
      <div className={styles.imagenPromo}>
        <img
          src='https://webimages.terramarbrands.com.mx/webpage/popupWebMexico/popUpOctubre2026-2.jpg'
          alt=''
          width='100%'
        />
      </div>
      {/* <div className={styles.promoCountDown} /> */}
    </div>
  );
}
